<template>
  <router-view
    class="full-height full-width LoginView"
    :style="{ backgroundImage: 'url(' + backgroundImageSource + ')' }"></router-view>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'LoginView',
    components: {
    },
    data() {
      return {
      }
    },
    computed: {
      ...mapGetters({
      'getLoginBackgroundImage': 'user/getLoginBackgroundImage',
    }),
      /**
       * src de la imagen de fondo
       */
      backgroundImageSource() {
        if (this.getLoginBackgroundImage) {
            return 'data:image/png;base64,' + this.getLoginBackgroundImage
        } else {
            return require('../assets/login-background.jpg');
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .LoginView{
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center top;
    background-attachment: fixed;
  }
</style>
